import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SecurityLexiClient } from '@lexi-clients/lexi';

@Injectable({
  providedIn: 'root'
})
export class WatermarkService {
  private readonly texteWatermark$ = new BehaviorSubject<string>('');
  private readonly visible$ = new BehaviorSubject<boolean>(false);

  constructor(private readonly securityLexiClient: SecurityLexiClient) {
    // L'initialisation se fait maintenant via AppInitService
  }

  public initialiserWatermark(): void {
    this.securityLexiClient.getWatermark().subscribe({
      next: (watermark: string) => {
        if (watermark) {
          this.afficherWatermark(watermark);
        }
      },
      error: (error) => {
        console.warn('Erreur lors du chargement de la configuration watermark:', error);
      }
    });
  }

  public afficherWatermark(texte: string): void {
    this.texteWatermark$.next(texte);
    this.visible$.next(true);
  }

  public masquerWatermark(): void {
    this.visible$.next(false);
  }

  public get texte$() {
    return this.texteWatermark$.asObservable();
  }

  public get estVisible$() {
    return this.visible$.asObservable();
  }
}